import { FLAGS } from '~/constants/flags'
import { ADMIN_ROUTES, ORDER_ROUTES } from '~/constants/router'
import { orderRoles } from '~/modules/auth/conditions'
import { lazyRetry } from '~/utils/lazyRetry'

const OrderList = lazyRetry(() => import('~/pages/Orders/OrderList'))
const OrderDetail = lazyRetry(() => import('~/pages/Orders/OrderDetail'))
const PantryOrderList = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.OrderPage })),
)
const PantryOrderDetail = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.OrderDetailPage })),
)
const CovaOrderList = lazyRetry(() => import('~/pages/Orders/CovaOrderList'))
const CovaOrderListV2 = lazyRetry(
  () => import('~/pages/Orders/CovaOrderListV2'),
)
const GreenlineOrderListV2 = lazyRetry(
  () => import('~/pages/Orders/GreenlineOrderListV2'),
)
const CovaOrderDetail = lazyRetry(
  () => import('~/pages/Orders/CovaOrderDetail'),
)
const GreenlineOrderList = lazyRetry(
  () => import('~/pages/Orders/GreenlineOrderList'),
)
const GreenlineOrderDetail = lazyRetry(
  () => import('~/pages/Orders/GreenlineOrderDetail'),
)
const ShopifyOrderList = lazyRetry(
  () => import('~/pages/Orders/ShopifyOrderList'),
)
const ShopifyOrderDetail = lazyRetry(
  () => import('~/pages/Orders/ShopifyOrderDetail'),
)
const CovaOrderDetailV2 = lazyRetry(
  () => import('~/pages/Orders/CovaOrderDetailV2'),
)
const GreenlineOrderDetailV2 = lazyRetry(
  () => import('~/pages/Orders/GreenlineOrderDetailV2'),
)
const FlowhubOrderList = lazyRetry(
  () => import('~/pages/Orders/FlowhubOrderList'),
)
const FlowhubOrderDetail = lazyRetry(
  () => import('~/pages/Orders/FlowhubOrderDetail'),
)
const LightspeedOrderList = lazyRetry(
  () => import('~/pages/Orders/LightspeedOrderList'),
)
const LightspeedOrderDetail = lazyRetry(
  () => import('~/pages/Orders/LightspeedOrderDetail'),
)

const OrderRouters = [
  {
    path: `${ADMIN_ROUTES.STORE}${ORDER_ROUTES.ORDERS}`,
    component: OrderList,
    pantryComponent: PantryOrderList,
    pantryDebugGate: true,
    covaComponent: CovaOrderList,
    greenlineComponent: GreenlineOrderList,
    shopifyComponent: ShopifyOrderList,
    covaComponentV2: CovaOrderListV2,
    greenlineComponentV2: GreenlineOrderListV2,
    flowhubComponentV2: FlowhubOrderList,
    lightspeedComponentV2: LightspeedOrderList,
    featureFlag: FLAGS.ACD_12446,
    layout: 'admin',
    exact: true,
    roles: orderRoles,
    routeName: 'Orders List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ORDER_ROUTES.TRASH_ORDERS}`,
    component: OrderList,
    layout: 'admin',
    exact: true,
    roles: orderRoles,
    xProps: {
      isTrash: true,
    },
    routeName: 'Orders Trash List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ORDER_ROUTES.CREATE_ORDER}`,
    component: OrderDetail,
    layout: 'admin',
    exact: true,
    roles: orderRoles,
    routeName: 'Order Create',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ORDER_ROUTES.EDIT_ORDER}`,
    component: OrderDetail,
    pantryComponent: PantryOrderDetail,
    pantryDebugGate: true,
    covaComponent: CovaOrderDetail,
    greenlineComponent: GreenlineOrderDetail,
    shopifyComponent: ShopifyOrderDetail,
    covaComponentV2: CovaOrderDetailV2,
    greenlineComponentV2: GreenlineOrderDetailV2,
    flowhubComponentV2: FlowhubOrderDetail,
    lightspeedComponentV2: LightspeedOrderDetail,
    featureFlag: FLAGS.ACD_12446,
    layout: 'admin',
    exact: true,
    roles: orderRoles,
    xProps: {
      isEditing: true,
    },
    routeName: 'Order Edit',
  },
]

export default OrderRouters
